// 删除某一图片
export const EVENT_LABEL_DELETE = 'event_deleted';
// 收藏某一图片
export const EVENT_LABEL_COLLECTED = 'event_collected';
// 取消收藏某一图片
export const EVENT_LABEL_UNCOLLECTED = 'event_uncollected';
// 历史记录重新拉取记录总数事件，只是拉取总数，并不是刷新历史记录页面
export const EVENT_LABEL_HISTORY_RELOAD = 'event_history_reload';
// 批量收藏图片成功
export const EVENT_LABEL_BATCH_COLLECTED = 'event_batch_collection';
// 批量取消收藏图片成功
export const EVENT_LABEL_BATCH_UNCOLLECTED = 'event_batch_uncollection';
// 批量删除图片成功
export const EVENT_LABEL_BATCH_DELETED = 'event_batch_deleted';
// 排序重置
export const EVENT_LABEL_INIT_RESORT = 'event_init_resort';

export const EVENT_LABEL_GENERATE_SUCCESS = 'event_label_generate_success';
